import type { ReactNode } from 'react';

import styles from './telemetry-card.module.scss';

export type TelemetryCardProps = {
  label: string;
  value: ReactNode;
  /** Optional leading icon (Phosphor `*Icon`). */
  icon?: ReactNode;
};

/** Compact telemetry stat card (Total/Daily Runtime, External/Battery Voltage). */
export function TelemetryCard({ label, value, icon }: TelemetryCardProps) {
  return (
    <div className={styles.card}>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
}
